//EXTERNAL
import React from "react"
//COMPONENTS
import Article from "../components/Article"
import Header from "../components/Header"
import Story from "../components/Story"
//ASSETS
import PicnicLogo from "../assets/picnic-logo-white.png"
//FUNCTIONS

export default function Lander({ isDesktop }) {
  const path = "https://ads.picnic-media.com/"
  // Placeholder is Picnic Tinder creative
  const creativeId = "000-000-picnic-test"
  function buildFormat() {
    return <Story path={buildPath()} id={creativeId} />
  }

  function buildPath() {
    return path + creativeId
  }
  return (
    <div className="bg-pink">
      <Header Logo={PicnicLogo} />
      <Article isDesktop={isDesktop} format={buildFormat()} />
    </div>
  )
}
